import styled from "styled-components";

const StyledFlexContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

export default StyledFlexContainer;
